export default __webpack_public_path__ + "img/survey.a769ec5a.png";